import { TableCell } from '@mui/material';

import { useSxStyles } from './useStyles';

export type PropsHeaderType = {
  title: string;
};

export const TableHeaderColumn = (props: PropsHeaderType) => {
  const sxStyles = useSxStyles();
  return <TableCell sx={sxStyles.hdWidth}>{props.title}</TableCell>;
};

export type PropsDataType = {
  title: string | number | string[];
  first?: boolean;
};

export const TableDataColumn = (props: PropsDataType) => {
  const sxStyles = useSxStyles();
  return (
    <TableCell
      sx={{ ...sxStyles.tdWidth, ...(props.first ? sxStyles.first : {}) }}
    >
      {props.title}
    </TableCell>
  );
};
